<template>
  <v-card class="mx-auto" max-width="600px">
    <div class="pa-3 d-flex align-center">
      <h2>Alienação de Equipamento</h2>

      <v-spacer />

      <v-alert
        type="error"
        v-show="error"
        transition="scale-transition"
        icon="mdi-alert-octagon-outline"
      >
        {{ errorMessage }}
      </v-alert>

      <v-spacer />

      <v-btn color="#B14949" icon @click="close">
        <v-icon color="#B14949">mdi-close</v-icon>
      </v-btn>
    </div>

    <v-dialog v-model="dialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{
              this.currentEquipment.alienated
                ? 'Tem certeza em desalienar este equipamento?'
                : 'Tem certeza em alienar este equipamento?'
            }}
          </div>

          <v-btn class="ma-1" color="grey" text @click="dialog = false">
            Não
          </v-btn>

          <v-btn class="ma-1" color="#B14949" text @click="alienateEquipment">
            Sim
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="confirmDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            Ao confirmar todas as Ordens de Serviço não fechadas serão
            removidas.
          </div>

          <v-btn class="ma-1" color="grey" text @click="confirmDialog = false">
            Cancelar
          </v-btn>

          <v-btn class="ma-1" color="#B14949" text @click="submit">
            Confirmar
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-window v-model="step" touchless>
      <v-window-item :value="0">
        <v-form
          class="form"
          ref="firstForm"
          v-model="firstValid"
          lazy-validation
        >
          <v-row class="px-4 ma-0">
            <v-col class="pb-0" cols="12">
              <label class="label">Motivo</label>
              <v-textarea
                hide-details="auto"
                :disabled="currentEquipment.alienated"
                no-resize
                rows="3"
                v-model="currentEquipment.alienationMotive"
                :rules="[
                  (v) =>
                    currentEquipment.alienated || !!v || 'Motivo requerido',
                ]"
                outlined
                class="text-area-input"
              ></v-textarea>
            </v-col>
            <v-col class="pb-0" cols="12">
              <v-menu
                ref="menuAlienationDate"
                v-model="menuAlienationDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <label class="label">Data alienação</label>
                  <v-text-field
                    hide-details="auto"
                    v-model="alienationDate"
                    v-mask="['##/##/####']"
                    prepend-inner-icon="mdi-calendar"
                    @blur="
                      currentEquipment.alienationDate =
                        parseDate(alienationDate)
                    "
                    v-bind="attrs"
                    v-on="on"
                    :rules="[
                      (v) =>
                        currentEquipment.alienated ||
                        !!v ||
                        'Data de alienação requerida',
                    ]"
                    :disabled="currentEquipment.alienated"
                    outlined
                    class="primary-input"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="currentEquipment.alienationDate"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1900-01-01"
                  no-title
                  @change="save"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-window-item>

      <v-window-item :value="1">
        <div class="fill-height text-center pa-8">
          <v-icon large color="success"> mdi-checkbox-marked-circle </v-icon>

          <span style="display: block; margin-top: 10px; font-size: 1.2rem">
            {{
              this.currentEquipment.alienated
                ? 'Equipamento desalienado com sucesso!'
                : 'Equipamento alienado com sucesso!'
            }}
          </span>
        </div>
      </v-window-item>
    </v-window>

    <v-divider class="mt-5"></v-divider>

    <v-card-actions>
      <v-btn @click="close" v-if="step === 0" class="ml-4" color="#B14949">
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="#426483" depressed @click="next" :loading="loading">
        {{ buttonText }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

@media (max-width: 600px) {
  .v-card__text {
    padding: 0;
  }
}
</style>

<script>
import ApiService from '../../../../services/ApiService'

export default {
  props: {
    equipment: Object,
  },

  created() {
    if (this.equipment) {
      this.currentEquipment = this.equipment
      if (this.equipment.alienationDate != null) {
        this.alienationDate = this.formatInitialDate(
          this.equipment.alienationDate
        )
      }
    }
  },

  data: () => ({
    step: 0,
    errorMessage: '',
    menuAlienationDate: false,
    loading: false,
    firstValid: false,
    error: false,
    dialog: false,
    confirmDialog: false,
    alienationDate: null,
    alienated: false,
    currentEquipment: {
      id: 0,
      alienated: false,
      alienationMotive: '',
      alienationDate: null,
    },
    alienationMotiveRules: [
      (v) => currentEquipment.alienated || !!v || 'Motivo requerido',
    ],
    alienationDateRules: [
      (v) => currentEquipment.alienated || !!v || 'Data da alienação requeirda',
    ],

    apiService: new ApiService(),
  }),

  computed: {
    buttonText() {
      switch (this.step) {
        case 0:
          return this.currentEquipment.alienated ? 'Desalienar' : 'Alienar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.dialog = true
        }
      } else {
        this.close()
      }
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },

    save(date) {
      this.alienationDate = this.formatInputDate(
        this.currentEquipment.alienationDate
      )
      this.$refs.menuAlienationDate.save(date)
    },

    alienateEquipment() {
      if (this.currentEquipment.alienated) {
        this.submit()
      } else {
        this.dialog = false
        this.confirmDialog = true
      }
    },

    async submit() {
      this.loading = true

      const equipment = {
        Id: this.currentEquipment.id,
        Alienated: !this.currentEquipment.alienated,
        AlienationMotive: !this.currentEquipment.alienated
          ? this.currentEquipment.alienationMotive
          : '',
        AlienationDate: !this.currentEquipment.alienated
          ? this.currentEquipment.alienationDate
          : null,
      }

      await this.apiService
        .post('equipment/alienate', equipment)
        .then(() => {
          this.dialog = false
          this.step++
          this.$router.push('/equipment')
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
    },
  },
}
</script>
